import { useEffect, useMemo, useState } from 'react';

import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadFull } from 'tsparticles'; // if you are going to use `loadFull`, install the "tsparticles" package too.

export default function Confetti({ trigger }) {
  const [init, setInit] = useState(false);

  // this should be run only once per application lifetime
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const options = useMemo(
    () => ({
      detectRetina: true,
      fpsLimit: 120,
      particles: {
        number: {
          value: trigger ? 1000 : 0,
        },
        color: {
          value: ['#FF5A86', '#953AFE', '#FFC326', '#46C0FF'],
        },
        shape: {
          type: ['square', 'circle', 'star', 'hexagon'],
        },
        opacity: {
          value: { min: 0, max: 1 },
          animation: {
            enable: true,
            minimumValue: 0,
            speed: 0.5,
            startValue: 'max',
            destroy: 'min',
          },
        },
        links: {
          enable: false,
        },
        size: {
          value: { min: 1, max: 5 },
        },
        life: {
          duration: {
            value: 200 / 120,
          },
          count: 1,
        },
        move: {
          angle: {
            value: 45,
            offset: 0,
          },
          drift: {
            min: -0,
            max: 0,
          },
          enable: true,
          gravity: {
            enable: true,
            acceleration: 20,
          },
          speed: 90,
          decay: 1 - 0.9,
          direction: -90,
          random: true,
          straight: false,
          outModes: {
            default: 'none',
            bottom: 'destroy',
          },
        },
        rotate: {
          value: {
            min: 0,
            max: 360,
          },
          direction: 'random',
          animation: {
            enable: true,
            speed: 60,
          },
        },
        tilt: {
          direction: 'random',
          enable: true,
          value: {
            min: 0,
            max: 360,
          },
          animation: {
            enable: true,
            speed: 60,
          },
        },
        roll: {
          darken: {
            enable: true,
            value: 25,
          },
          enable: true,
          speed: {
            min: 15,
            max: 25,
          },
        },
        wobble: {
          distance: 20,
          enable: true,
          speed: {
            min: -15,
            max: 15,
          },
        },
      },
      emitters: {
        autoPlay: true,
        name: 'confetti',
        startCount: 80,
        position: { x: 50, y: 50 },
        size: {
          width: 0,
          height: 0,
        },
        rate: {
          delay: 0,
          quantity: 10,
        },
        life: {
          count: 1,
          duration: 0.1,
          delay: 0,
        },
      },
    }),
    [trigger]
  );

  if (init && trigger) {
    return (
      <div style={{ height: 0 }}>
        <Particles id="tsparticles" options={options} />
      </div>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}
